module.exports = __webpack_public_path__ + "static/hero-mob-img-6d81066c8b6493b2f9e7e0e0a0b11782.png";